// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","507":"PizzaCard"}[chunkId] + "." + {"72":"83a46814","187":"fd592c54","507":"d77cdb79"}[chunkId] + ".chunk.js";
};